/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Usage breakdown by LLM client/agent
 */
export type LLMClientUsage = {
  /**
   * Number of messages (session mode) or tool calls (tool_call mode)
   */
  activityCount: number;
  /**
   * Client/agent name (e.g., 'cursor', 'claude-code', 'cowork')
   */
  clientName: string;
};

/** @internal */
export const LLMClientUsage$inboundSchema: z.ZodMiniType<
  LLMClientUsage,
  unknown
> = z.pipe(
  z.object({
    activity_count: z.int(),
    client_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activity_count": "activityCount",
      "client_name": "clientName",
    });
  }),
);

export function llmClientUsageFromJSON(
  jsonString: string,
): SafeParseResult<LLMClientUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LLMClientUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LLMClientUsage' from JSON`,
  );
}
